module.exports = __webpack_public_path__ + "img/perfumeLily.f736d679.jpg";